import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContentContainer from "../components/ContentContainer";
import ContentZone from "../components/ContentZone";
import ImageContainer from "../components/ImageContainer";
import { WORKSHOP_CONFIG } from "../config/workshop";
import "./Home.css";

function Home() {
  const { t } = useTranslation();

  // Workshop information (used when showNextWorkshopBanner is true)
  const workshopDate = t("home.workshopDate");
  const workshopTime = t("home.workshopTime");
  const workshopLocation = t("home.workshopLocation");
  const workshopEvent = "Adopting Bitcoin";
  const workshopCountry = "El Salvador";
  const registrationFormUrl = "https://docs.google.com/forms/d/14lhtx1lqtHWVXSqquWF9uf9OH0T-74dCVm0rNJH1HDw/viewform";
  const eventUrl = "https://pretalx.com/ab25/talk/review/JSVG8CKRDZGVYE99JQ8KMKDSEE38HA7S";

  return (
    <div className="home-container">
      {WORKSHOP_CONFIG.showNextWorkshopBanner && (
      <ContentContainer>
      <div className="workshop-cta-banner">
        <div className="cta-banner-content">
          <a 
            href={eventUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-banner-logo-link"
            title="Adopting Bitcoin 2025"
          >
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/AB24-logo.png`}
              alt="Adopting Bitcoin 2024"
              className="cta-banner-logo"
            />
          </a>
          <div className="cta-banner-text">
            <h3 className="cta-banner-title">{t("home.nextWorkshop")}</h3>
            <p className="cta-banner-info">
              <span className="cta-date">{workshopDate}</span>
              <span className="cta-separator">•</span>
              <span className="cta-time">{workshopTime}</span>
              <span className="cta-separator">•</span>
              <span className="cta-location">{workshopLocation}</span>
            </p>
            <p className="cta-banner-event">
              <span className="cta-event">{workshopEvent}</span>
              <span className="cta-separator">•</span>
              <span className="cta-country">{workshopCountry}</span>
            </p>
          </div>
          <a 
            href={registrationFormUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-banner-button"
          >
            {t("home.registerNow")} →
          </a>
        </div>
      </div>
      </ContentContainer>
      )}

      <ContentContainer>
        <ContentZone
          imageSide="right"
          image={
            <ImageContainer
              src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_01.jpg`}
              alt="SeedSigner and Satochip components"
              rounded={true}
              overlay={true}
              rotate={-2}
              aspectRatio="4/3"
              maxWidth="600px"
            />
          }
        >
          <h1 className="home-title">
            <span className="title-line">{t("home.title")}</span>
            <span className="title-main">{t("home.titleMain")}</span>
          </h1>
          <p className="hero-description">
            {t("home.description")}
          </p>
          <Link to="/how" className="cta-button">
            {t("home.getStarted")} →
          </Link>
        </ContentZone>
      </ContentContainer>

      <ContentContainer>
        <ContentZone
          imageSide="left"
          className="bottom-section"
          image={
            <ImageContainer
          src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_02.jpg`}
          alt="SeedSigner device showing success message"
              rounded={false}
              overlay={false}
              rotate={3}
              offsetX={-15}
              aspectRatio="1/1"
              maxWidth="400px"
            />
          }
        >
          <h2 className="bottom-content-title">{t("home.bottomSectionTitle")}</h2>
          <p className="bottom-content-description">{t("home.bottomSectionDescription")}</p>
          <ul className="bottom-content-list">
            <li>{t("home.bottomSectionItem1")}</li>
            <li>{t("home.bottomSectionItem2")}</li>
            <li>{t("home.bottomSectionItem3")}</li>
            <li>{t("home.bottomSectionItem4")}</li>
          </ul>
        </ContentZone>
      </ContentContainer>
    </div>
  );
}

export default Home;
